import { render, staticRenderFns } from "./repru-status-bar.vue?vue&type=template&id=389346f7&scoped=true"
import script from "./repru-status-bar.vue?vue&type=script&lang=js"
export * from "./repru-status-bar.vue?vue&type=script&lang=js"
import style0 from "./repru-status-bar.vue?vue&type=style&index=0&id=389346f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389346f7",
  null
  
)

export default component.exports